import {yupResolver} from "@hookform/resolvers/yup";
import {Button, Stack, TextField, CircularProgress, Typography, Box} from "@mui/material";
import {useForm} from "react-hook-form";
import * as yup from "yup";
import useApiRequest from "../../hooks/useApiRequest";
import {useState} from "react";
import {useSnackbar} from "notistack";

const schema = yup.object().shape({
  email: yup.string().required("El email es obligatorio").email("Email inválido"),
  name: yup.string().required("El nombre es obligatorio"),
  surname: yup.string().required("El apellido es obligatorio")
});

const TicketInvitationForm = ({onSuccess, onCancel}) => {
  const {enqueueSnackbar} = useSnackbar();
  const {loading, create} = useApiRequest({
    baseUrl: `${process.env.REACT_APP_API_AUTH}/ts-bridge/generate-ticket`,
    resource: "tickets"
  });

  const {
    register,
    handleSubmit,
    formState: {errors},
    reset
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: "",
      name: "",
      surname: ""
    }
  });

  const [emailExists, setEmailExists] = useState(false);
  const handleSave = async (data) => {
    setEmailExists(false);
    const tenantId = process.env.REACT_APP_PANEL_TENANT_ID_TS_SUPPORT;
    const productId = process.env.REACT_APP_PANEL_PRODUCT_ID_IDENTITY;

    const payload = {
      email: data.email,
      ticket_type: "invitation",
      name: data.name,
      surname: data.surname,
      tenant_id: tenantId,
      product_id: productId
    };

    const result = await create(payload);
    if (!result?.success) return;

    reset();
    enqueueSnackbar("Ticket de invitación generado correctamente", {
      variant: "success",
      message: "Ticket de invitación generado correctamente",
      fields: [{label: "ID", value: result.data?.id}]
    });
    if (onSuccess) onSuccess();
  };

  if (loading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="200px">
        <CircularProgress />
        <Typography mt={2}>Generando ticket de invitación...</Typography>
      </Box>
    );
  }

  return (
    <Stack direction="column" spacing={2} minWidth={"400px"}>
      <TextField
        label="Email *"
        {...register("email")}
        error={!!errors.email || emailExists}
        helperText={emailExists ? "Este usuario ya existe en el panel." : errors.email?.message}
        type="email"
        variant="outlined"
      />

      <TextField
        label="Nombre *"
        {...register("name")}
        error={!!errors.name}
        helperText={errors.name?.message}
        variant="outlined"
      />

      <TextField
        label="Apellido *"
        {...register("surname")}
        error={!!errors.surname}
        helperText={errors.surname?.message}
        variant="outlined"
      />

      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(handleSave)}
          disabled={loading}
          sx={{flex: 1}}
        >
          Generar Ticket
        </Button>
        <Button variant="outlined" onClick={onCancel} sx={{flex: 1}}>
          Cancelar
        </Button>
      </Stack>
    </Stack>
  );
};

export default TicketInvitationForm;
